'use client';
import { FC } from 'react';
import Section from '@egalite/ui/IncluiPCD/About/Section';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

const Content: FC<{ content: { title: string, videos: { videoId: string }[] }[] }> = ({ content }) => {
    return Array.isArray(content) && content.length > 0 ? (
        <>
            <Section title="Todos os Conteúdos">
                <div className="relative swiper-container-wrapper"> 
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        loop={true}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }}
                        modules={[Navigation]}
                        className="swiper-container"
                        breakpoints={{
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 30,
                            },
                            1440: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                        }}
                    >
                        {content.flatMap(section => section.videos).map((video, index) => (
                            <SwiperSlide key={index} className="flex justify-center items-center">
                                <a href={`https://www.youtube.com/watch?v=${video.videoId}`} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={`https://img.youtube.com/vi/${video.videoId}/0.jpg`}
                                        alt="Video thumbnail"
                                        className="w-full h-auto rounded-xl"
                                        style={{ maxHeight: '500px' }}
                                    />
                                </a>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="swiper-button-prev" style={{ position: 'absolute', left: '-50px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, color: '#000' }} />
                    <div className="swiper-button-next" style={{ position: 'absolute', right: '-50px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, color: '#000' }} />
                </div>
            </Section>
        </>
    ) : null;
};

export default Content;
